import { PINNED_SPACE_POST_LIST_ACTION } from 'core/constants/Actions'
import { Action } from 'core/models/ActionTypes'
import { SpacePost } from 'core/models/Space'

const intialState: { pinnedSpacePosts: SpacePost[], count: number, currentPage: number, isLoading: boolean } = {
  pinnedSpacePosts: [],
  isLoading: false,
  count: 0,
  currentPage: 0
}

interface ActionType extends Action {
  payload: {
    pinnedSpacePosts: SpacePost[];
    count: number;
    currentPage: number;
  }
}

export default function pinnedSpacePostListReducer(state = intialState, action: ActionType) {

  switch (action.type) {
    case PINNED_SPACE_POST_LIST_ACTION.REQUEST:
      return { ...state, isLoading: true }

    case PINNED_SPACE_POST_LIST_ACTION.SUCCESS:
      const { pinnedSpacePosts, count, currentPage } = action.payload;
      return { ...state, pinnedSpacePosts, count, currentPage, isLoading: false }

    case PINNED_SPACE_POST_LIST_ACTION.FAILURE:
      return { ...state, ...intialState }

    default:
      return state
  }
}